export const getFileFromCSV = (csvString: string, fileName: string, folderName: string) => {
  const blob = new Blob([csvString], { type: 'text/csv' });
  const file = new File([blob], `${folderName}/${fileName}.csv`, { type: 'text/csv' });
  return file;
};
